import * as types from "../../actionTypes";

export const get = () => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_REQUEST
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_SUCCESS,
    payLoad: data
  };
};

export const getFailure = (error) => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_FAILURE,
    error: error
  };
};
